import { Icon } from "@/DesignSystem";

import styles from "./ElementWithIcon.module.scss";

import MedfarMedfarLogo from "@/DesignSystem/Atoms/Icons/Types/MedfarMedfarLogo/medfar-medfar-logo.svg";

interface IElementWithMyleLogoProps {
    children?: JSX.Element;
    includeIcon?: boolean;
    dataCy?: string;
}

function ElementWithIcon(props: IElementWithMyleLogoProps): JSX.Element {
    if (props.includeIcon) {
        return (
            <div className={styles.container}>
                <div className={styles.logoContainer}>
                    <Icon size="sm" dataCy={props.dataCy}>
                        <MedfarMedfarLogo />
                    </Icon>
                </div>
                {props.children}
            </div>
        );
    }

    return props.children;
}

export { ElementWithIcon };
